import { render, staticRenderFns } from "./customizePagination.vue?vue&type=template&id=7560d0cc&scoped=true"
import script from "./customizePagination.vue?vue&type=script&lang=js"
export * from "./customizePagination.vue?vue&type=script&lang=js"
import style0 from "./customizePagination.vue?vue&type=style&index=0&id=7560d0cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7560d0cc",
  null
  
)

export default component.exports